import { SubscriptionStatus } from "../../OrderFlow/utils/orderFlowUtils";
import { RecipeDisplayNameType } from "../../Shared/components/OrderSummary/OrderSummary.request";
import { buildQuantityString } from "../Orders/OrderDetailsAccordion/utils/orderDetailsUtils";
import { SubscriptionStatusValues } from "../Subscriptions/subscriptionsUtils/subscriptions-types";

export const getDayBreakdown = (day, noMealsSelectedText, recipeDisplayNameType) => {
  const recipeName = (recipe) =>
    recipeDisplayNameType === RecipeDisplayNameType.SHORT_NAME && recipe?.recipeShortName !== ""
      ? recipe?.recipeShortName
      : recipe?.recipeName;

  let dayBreakdown = [];
  day.meal_dates.forEach((mealDate) => {
    mealDate.meal_list.forEach((meal) => {
      let targetDay = dayBreakdown.find((day) => day.day === mealDate.meal_date);
      if (!targetDay) {
        dayBreakdown.push({
          day: mealDate.meal_date,
          meals: [
            {
              mealType: meal.meal_type,
              mealQuantity: meal.quantity,
              recipes: [
                {
                  qty: meal.quantity,
                  name: recipeName(meal),
                  quantityString: buildQuantityString(meal.quantity, recipeName(meal), noMealsSelectedText),
                },
              ],
            },
          ],
        });
      } else {
        let targetMeal = targetDay.meals.find((m) => m.mealType === meal.meal_type);
        if (!targetMeal) {
          targetDay.meals.push({
            mealType: meal.meal_type,
            mealQuantity: meal.quantity,
            recipes: [
              {
                qty: meal.quantity,
                name: recipeName(meal),
                quantityString: buildQuantityString(meal.quantity, recipeName(meal), noMealsSelectedText),
              },
            ],
          });
        } else {
          targetMeal.mealQuantity += meal.quantity;
          let targetRecipe = targetMeal.recipes.find((recipe) => recipe.name == meal.recipeName);
          if (!targetRecipe) {
            targetMeal.recipes.push({
              qty: meal.quantity,
              name: recipeName(meal),
              quantityString: buildQuantityString(meal.quantity, recipeName(meal), noMealsSelectedText),
            });
          } else {
            targetRecipe.qty += meal.quantity;
          }
        }
      }
    });
  });
  return dayBreakdown;
};

export const CancelSubscriptionMode = {
  None: 0,
  ShowCancellationInstructions: 10,
  AllowUserToCancel: 20,
};

export const getCurrentSubscriptionStatus = (status) => {
  switch (status) {
    case SubscriptionStatus.Paused:
      return SubscriptionStatusValues.PAUSED;
    case SubscriptionStatus.Active:
      return SubscriptionStatusValues.ACTIVE;
    case SubscriptionStatus.Complete:
      return SubscriptionStatusValues.COMPLETE;
    case SubscriptionStatus.Cancelled:
      return SubscriptionStatusValues.CANCELLED;
    default:
      return SubscriptionStatusValues.NONE;
  }
};
